import React from 'react';
import styled from 'styled-components';

import TokenThumbnail from '../TokenThumbnail';

const ThisTokenThumbnail = styled(TokenThumbnail)`
  padding: 20px 20px 0;
  border-radius: 0;
  box-shadow: 0px 2px 1px rgba(0,0,0,0.1);

  img {
    border-radius: 6px;
    box-shadow: 0px 3px 11px rgba(0, 0, 0, 0.3);
  }
`;

const PlayerCard = ({ children, player={} }) => (
  <ThisTokenThumbnail ipfsPath={player.image}>
    {children}
  </ThisTokenThumbnail>
);

export default PlayerCard;



// WEBPACK FOOTER //
// ./src/components/ui/PlayerCard.js